module.exports = __webpack_public_path__ + "stylesheets/m-medium-landing_9d28a6855a0274832dc4bbd0ad8ebced.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/mobile/m-medium-landing.less
// module id = BGDY
// module chunks = 153